import { WorkflowOperatorKey } from 'dashboard/models/workflow';

export const UNARY_OPERATORS = [
  WorkflowOperatorKey.IsBlank,
  WorkflowOperatorKey.IsNotBlank,
  WorkflowOperatorKey.IsFalsy,
  WorkflowOperatorKey.IsTruthy,
];
